import React, {FC} from 'react';
import {FormNameEnum} from 'filters-selections';
import {Form} from 'forms';
import {IWithDisabled} from 'models/common';

type Props = IWithDisabled;

export const PermissionNeededCheckbox: FC<Props> = ({disabled}) => (
  <Form.Checkbox name={FormNameEnum.permissionNeeded} label="Permission Needed" disabled={disabled} />
);

export const CredentialingCheckbox: FC<Props> = ({disabled}) => (
  <Form.Checkbox name={FormNameEnum.credentialing} label="Credentialing" disabled={disabled} />
);

export const PermissionInPerpetuityCheckbox: FC<Props> = ({disabled}) => (
  <Form.Checkbox name={FormNameEnum.permissionInPerpetuity} label="Permission in Perpetuity" disabled={disabled} />
);

export const ReuseFlagCheckbox: FC<Props> = ({disabled}) => (
  <Form.Checkbox name={FormNameEnum.reuseFlag} label="Reuse Flag" disabled={disabled} />
);
